/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import React, {PropsWithChildren} from 'react';
import {ContextShape} from "../../util/interfaces";
import {ControlVariant, ThemeProvider} from "@dvrd/dvr-controls";
import {PLATFORM_BASE_COLOR, PLATFORM_CONTRAST_COLOR} from "../../util/constants";

function deprecated() {
    console.warn('Usage of object onChange functions is deprecated, use direct context onChange instead.');
}

const defaultContext: ContextShape = {
    theme: {
        baseColor: PLATFORM_BASE_COLOR,
        contrastColor: PLATFORM_CONTRAST_COLOR,
        borderColor: 'color-gray-4',
        onChange: deprecated,
        controlVariant: ControlVariant.SIMPLE,
    },
};
export const AppContext = React.createContext(defaultContext);

interface State {
    context: ContextShape;
}

export default class AppContextProvider extends React.PureComponent<PropsWithChildren<any>, State> {
    constructor(props: PropsWithChildren<any>) {
        super(props);
        this.state = {context: defaultContext};
    }


    render = () => {
        const {context} = this.state;
        return (
            <AppContext.Provider value={context}>
                <ThemeProvider theme={context.theme}>
                    {this.props.children}
                </ThemeProvider>
            </AppContext.Provider>
        );
    };
}